module.exports = __webpack_public_path__ + "static/jerome-harris-c6f6401dade449a766aa4626cd68f7f1.jpg";